import { useState } from "react";
import { api } from "@/lib/api";

export default function FreeAgentTmValueCard({ pesId, onChanged }) {
    const [val, setVal] = useState("");
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState(null);

    const save = async () => {
        const v = parseFloat(String(val).replace(",", "."));
        if (!(v >= 0)) { setMsg({ err: true, t: "Inserisci un valore valido in milioni (es. 45)" }); return; }
        setBusy(true); setMsg(null);
        try {
            await api.put(`/admin/tm-migration/free-agent/${pesId}`, { market_value_mln: v });
            setMsg({ t: `Valore TM impostato: ${v} mln (agg. a oggi).` });
            setVal("");
            onChanged?.();
        } catch (e) {
            setMsg({ err: true, t: e.response?.data?.detail || "Errore durante il salvataggio" });
        } finally { setBusy(false); }
    };

    return (
        <div className="op-card p-4 mt-4" data-testid="fa-tm-manual-card">
            <div className="op-label text-[10px] mb-1">// ADMIN · Valore TM manuale svincolato (milioni)</div>
            <div className="op-mono text-[9px] text-t5c6370 mb-2">È il prezzo minimo in asta. La data viene messa a oggi.</div>
            <div className="flex items-center gap-2">
                <input type="number" min="0" step="0.1" value={val} onChange={(e) => setVal(e.target.value)} placeholder="es. 45"
                    className="w-40 bg-t0a0b0d border border-t22252a focus:border-t00bfff outline-none text-tffffff text-sm px-3 py-2 op-mono"
                    data-testid="fa-tm-manual-input" />
                <span className="op-mono text-[11px] text-t8f95a3">mln €</span>
                <button onClick={save} disabled={busy} data-testid="fa-tm-manual-save"
                    className="op-mono text-[11px] uppercase tracking-wider px-3 py-2 border border-t00bfff/50 text-t00bfff hover:bg-t00bfff/10 transition-colors disabled:opacity-40">
                    Salva valore
                </button>
            </div>
            {msg && <div className={`mt-2 text-xs ${msg.err ? "text-tff3b30" : "text-t7ce38b"}`} data-testid="fa-tm-manual-msg">{msg.t}</div>}
        </div>
    );
}
